export default function addContext(Component, contextTypes) {
    Component.contextTypes = Component.contextTypes || {};
    Object.assign(Component.contextTypes, contextTypes);

    return Component;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2-ui/lib/component-helpers/addContext.js
// module id = 968
// module chunks = 0